import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller.ts"
import { IncomingInvoice } from "@/models/incoming-invoice.model.ts"
import type { IIncomingInvoice } from "@/interfaces/api/incoming-invoice.interface.ts"
import { IncomingInvoiceRepository } from "@/repositories/incoming-invoice-repository.ts"
import { useIncomingInvoiceStore } from "@/store/incoming-invoices.store.ts"
import { storeToRefs } from "pinia"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers.ts"

export class IncomingInvoiceController extends GenericModelController<
  IncomingInvoice,
  IIncomingInvoice,
  IncomingInvoiceRepository
> {
  constructor() {
    const incomingInvoiceStore = useIncomingInvoiceStore()
    const { incomingInvoices } = storeToRefs(incomingInvoiceStore)
    const storeFunctionsConfig = {
      collection: incomingInvoices
    }

    super(IncomingInvoice, storeFunctionsConfig, new IncomingInvoiceRepository())

    this.socketSynchronizationHandlers = useSocketSynchronizationHandlers(
      IncomingInvoice,
      incomingInvoices
    )
  }
}
